import { render, staticRenderFns } from "./loaderSVG.vue?vue&type=template&id=3c3b2837&"
import script from "./loaderSVG.vue?vue&type=script&lang=js&"
export * from "./loaderSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports